import { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import format from 'date-fns/format';
import { timeFormats } from 'app/constants';

export const UserAndTimeBlock = ({ isCurrentUser, created, displayName }) => {
  const getMemoizedTime = useMemo(() => {
    return format(created.timestamp, timeFormats.MESSAGE_TIME);
  }, [created]);

  return (
    <Flex alignSelf={isCurrentUser ? 'flex-end' : 'flex-start'} pt={1}>
      {!isCurrentUser && (
        <Text
          color="textSubdued"
          fontSize="xxs"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          data-testid="messenger-display-name"
          maxWidth="228px"
          title={displayName}
        >
          {displayName}
        </Text>
      )}
      <Text
        color="textSubdued"
        fontSize="xxs"
        pl={1}
        data-testid="messenger-message-time"
      >
        {getMemoizedTime}
      </Text>
    </Flex>
  );
};
